import { isEntitled, IONICWrapper } from './common';
import { Roles, IN_PROGRESS_TEXT } from '../utils/constants';

const originDateTime10 = '10:00 AM - 02:00 PM';
const originDateTime06 = '06:00 AM - 08:00 AM';
const LA = 'Los Angeles';
export const LOAD_DATA = [
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Dallas',
    origin_state: 'TX',
    origin_from_date: 'Nov 16',
    origin_to_date_time: originDateTime10,
    origin_deadhead: '150',
    destination_city: 'Detroit',
    destination_state: 'MI',
    destination_from_date: 'Nov 18',
    destination_to_date_time: '02:00 PM - 09:00 PM',
    destination_deadhead: '50',
    total_weight: '20141',
    total_distance: '1185',
    total_stops: '1',
    trailer: 'Dry van',
    price: 0
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Seattle',
    origin_state: 'WA',
    origin_from_date: 'Nov 18',
    origin_to_date_time: originDateTime06,
    origin_deadhead: '50',
    destination_city: LA,
    destination_state: 'CA',
    destination_from_date: 'Nov 19',
    destination_to_date_time: '08:00 AM - 09:00 AM',
    destination_deadhead: '150',
    total_weight: '34000',
    total_distance: '1338',
    total_stops: '2',
    trailer: 'Dry van',
    price: 1000
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Atlanta',
    origin_state: 'GA',
    origin_from_date: 'Nov 22',
    origin_to_date_time: '04:00 AM - 06:00 AM',
    origin_deadhead: '40',
    destination_city: 'Jacksonville',
    destination_state: 'FL',
    destination_from_date: 'Nov 24',
    destination_to_date_time: '10:00 AM - 12:00 PM',
    destination_deadhead: '125',
    total_weight: '40000',
    total_distance: '346',
    total_stops: '0',
    trailer: 'Dry van',
    price: 690
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Dallas',
    origin_state: 'TX',
    origin_from_date: 'Nov 24',
    origin_to_date_time: '10:00 AM - 12:00 PM',
    origin_deadhead: '120',
    destination_city: 'St Louis',
    destination_state: 'MO',
    destination_from_date: 'Nov 25',
    destination_to_date_time: '09:00 PM - 10:00 PM',
    destination_deadhead: '70',
    total_weight: '25150',
    total_distance: '631',
    total_stops: '1',
    trailer: 'Dry van',
    price: 1240
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Denver',
    origin_state: 'CO',
    origin_from_date: 'Nov 28',
    origin_to_date_time: originDateTime10,
    origin_deadhead: '130',
    destination_city: 'Cleveland',
    destination_state: 'OH',
    destination_from_date: 'Nov 30',
    destination_to_date_time: '02:00 PM - 04:00 PM',
    destination_deadhead: '60',
    total_weight: '15555',
    total_distance: '1334',
    total_stops: '3',
    trailer: 'Reefer',
    price: 500
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: LA,
    origin_state: 'CA',
    origin_from_date: 'Dec 02',
    origin_to_date_time: '05:00 AM - 07:00 AM',
    origin_deadhead: '10',
    destination_city: 'Charlotte',
    destination_state: 'NC',
    destination_from_date: 'Dec 03',
    destination_to_date_time: '08:00 AM - 10:00 AM',
    destination_deadhead: '110',
    total_weight: '19998',
    total_distance: '2410',
    total_stops: '2',
    trailer: 'Dry van',
    price: 200
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Brimley',
    origin_state: 'MI',
    origin_from_date: 'Dec 04',
    origin_to_date_time: '10:00 AM - 11:00 AM',
    origin_deadhead: '0',
    destination_city: 'Springlake',
    destination_state: 'TX',
    destination_from_date: 'Dec 06',
    destination_to_date_time: '04:00 PM - 06:00 PM',
    destination_deadhead: '15',
    total_weight: '24500',
    total_distance: '1571',
    total_stops: '5',
    trailer: 'Dry van',
    price: 300
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Baton Rouge',
    origin_state: 'LA',
    origin_from_date: 'Dec 08',
    origin_to_date_time: '10:00 AM - 01:00 PM',
    origin_deadhead: '66',
    destination_city: 'Seattle',
    destination_state: 'WA',
    destination_from_date: 'Dec 9',
    destination_to_date_time: '08:00 AM - 10:00 AM',
    destination_deadhead: '20',
    total_weight: '30500',
    total_distance: '2514',
    total_stops: '0',
    trailer: 'Reefer',
    price: 500
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Rapid City',
    origin_state: 'SD',
    origin_from_date: 'Nov 16',
    origin_to_date_time: '04:00 AM - 05:00 AM',
    origin_deadhead: '89',
    destination_city: 'Denver',
    destination_state: 'CO',
    destination_from_date: 'Nov 18',
    destination_to_date_time: '12:00 PM - 01:00 PM',
    destination_deadhead: '0',
    total_weight: '36000',
    total_distance: '387',
    total_stops: '0',
    trailer: 'Dry van',
    price: 600
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Milwaukee',
    origin_state: 'WI',
    origin_from_date: 'Dec 16',
    origin_to_date_time: '08:00 AM - 08:30 AM',
    origin_deadhead: '117',
    destination_city: 'Chicago',
    destination_state: 'IL',
    destination_from_date: 'Dec 19',
    destination_to_date_time: '10:00 AM - 10:30 AM',
    destination_deadhead: '35',
    total_weight: '12800',
    total_distance: '93',
    total_stops: '0',
    trailer: 'Reefer',
    price: 450
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Green Bay',
    origin_state: 'WI',
    origin_from_date: 'Dec 19',
    origin_to_date_time: '8:00 AM',
    origin_deadhead: '143',
    destination_city: 'Madison',
    destination_state: 'WI',
    destination_from_date: 'Dec 20',
    destination_to_date_time: '12:00 PM',
    destination_deadhead: '47',
    total_weight: '13600',
    total_distance: '136',
    total_stops: '0',
    trailer: 'Dry van',
    price: 120
  },
  {
    schneider_loads_id: 'SNI_0000001',
    load_status: IN_PROGRESS_TEXT,
    origin_city: 'Nashville',
    origin_state: 'TN',
    origin_from_date: 'Nov 16',
    origin_to_date_time: '08:00 AM - 10:00 AM',
    origin_deadhead: '77',
    destination_city: 'Tampa',
    destination_state: 'FL',
    destination_from_date: 'Nov 17',
    destination_to_date_time: '10:00 PM - 11:59 PM',
    destination_deadhead: '68',
    total_weight: '19000',
    total_distance: '704',
    total_stops: '1',
    trailer: 'Dry van',
    price: 340
  }
];

export const ManageCardData = [
  {
    cradImg: './assets/icon/more-arrow.svg',
    profileHeading: 'My Profile',
    profileRouting: '/app/manage/ProfileDetails'
  },
  {
    cradImg: '/assets/icon/more-arrow.svg',
    profileHeading: 'Preferences',
    profileRouting: '/app/manage/Preferences'
  },
  {
    cradImg: './assets/icon/more-arrow.svg',
    profileHeading: 'Carrier Profile',
    profileRouting: '/app/manage/CarrierProfileDetails'
  },
  {
    cradImg: './assets/icon/more-arrow.svg',
    profileHeading: 'Manage Users',
    profileRouting: '/app/manage/ManageUser'
  },
  {
    cradImg: './assets/icon/more-arrow.svg',
    profileHeading: 'Manage My Capacity',
    profileRouting: '/app/manage/ManageMyCapacity'
  }
];

export const ManageMyCapacityData = [
  {
    carrierid: 'SPS858032',
    destinationCity: null,
    destinationCountry: null,
    destinationPostalCode: null,
    destinationState: null,
    destinationradius: 100,
    dropdate: null,
    favouritesearchindicator: false,
    id: '608',
    originCity: 'Green Bay',
    originCountry: null,
    originPostalCode: null,
    originState: 'WI',
    originradius: 100,
    pickupdate: '2020-07-25T05:03:33.077-05:00',
    searchdate: '2020-07-15T05:04:11.413-05:00',
    trailertype: 'Dry Van',
    userid: 'ujjwal.cts@gmail.com',
    vehicleType: 'Lane'
  },
  {
    carrierid: 'SPS858032',
    destinationCity: null,
    destinationCountry: null,
    destinationPostalCode: null,
    destinationState: null,
    destinationradius: 100,
    dropdate: null,
    favouritesearchindicator: false,
    id: '608',
    originCity: 'Green Bay',
    originCountry: null,
    originPostalCode: null,
    originState: 'WI',
    originradius: 100,
    pickupdate: '2020-07-25T05:03:33.077-05:00',
    searchdate: '2020-07-15T05:04:11.413-05:00',
    trailertype: 'Dry Van',
    userid: 'ujjwal.cts@gmail.com',
    vehicleType: 'Truck'
  },
  {
    carrierid: 'SPS858032',
    destinationCity: null,
    destinationCountry: null,
    destinationPostalCode: null,
    destinationState: null,
    destinationradius: 100,
    dropdate: null,
    favouritesearchindicator: false,
    id: '608',
    originCity: 'Green Bay',
    originCountry: null,
    originPostalCode: null,
    originState: 'WI',
    originradius: 100,
    pickupdate: '2020-07-25T05:03:33.077-05:00',
    searchdate: '2020-07-15T05:04:11.413-05:00',
    trailertype: 'Dry Van',
    userid: 'ujjwal.cts@gmail.com',
    vehicleType: 'Truck'
  }
];


export function getMyloadData() {
  return [
    ...(isEntitled('myLoad', 'carrierTendered')?
    [
        {
          count: 'carrierTenderedCount',
          cardImg: './assets/icon/checklist.svg',
          title: 'Carrier Tendered',
          myLoadRouting: '/app/MyLoad/CarrierTendered',
          className: 'carrier_tendered',
          class: 'carrier-tendered'
        }
      ]
      : []),
    ...(isEntitled('myLoad', 'carrierAssigned')
      ? [
        {
          count: 'carrierAssignedCount',
          cardImg: './assets/icon/carrier.svg',
          title: 'Carrier Assigned',
          myLoadRouting: '/app/MyLoad/CarrierAssigned',
          className: 'carrier_assigned',
          class: 'carrier-assigned'
        }
      ]
      : []),
    ...(isEntitled('myLoad', 'driverAssigned')
      ? [
        {
          count: 'driverAssignedCount',
          cardImg: IONICWrapper.details.auth.user.roles.includes(
            Roles.carrierDispatcher
          )
            ? './assets/icon/driver.svg'
            : './assets/icon/carrier.svg',
          title: IONICWrapper.details.auth.user.roles.includes(
            Roles.carrierDispatcher
          )
            ? 'Driver Assigned'
            : 'Loads Assigned',
          myLoadRouting: '/app/MyLoad/DriverAssigned',
          className: 'driver_assinged',
          class: 'driver-assigned'
        }
      ]
      : []),
    ...(isEntitled('myLoad', 'inTransit')
      ? [
        {
          count: 'inTransitCount',
          cardImg: './assets/icon/transit.svg',
          title: 'In-Transit',
          myLoadRouting: '/app/MyLoad/InTransit',
          className: 'in-transit',
          class: 'in_transit'
        }
      ]
      : []),
    ...(isEntitled('myLoad', 'recentlyDeliveredLoads')
      ? [
        {
          count: 'deliveredNeedsPaperWorkCount',
          cardImg: "assets/icon/delivered.svg",
          title: "Delivered Needs PPWK",
          myLoadRouting: '/app/MyLoad/DeliveredNeedsPPWK',
          className: "delivered",
          class: "delivered_needs",
        },
      ]
      : []),
    ...(isEntitled('myLoad', 'recentlyDeliveredLoads')
      ? [
        {
          count: 'deliveredWithPaperWorkCount',
          cardImg: './assets/icon/recent.svg',
          title: 'Delivered With PPWK',
          myLoadRouting: '/app/MyLoad/DeliveredWithPPWK',
          className: 'recently_delivered',
          class: 'recently-delivered'
        }
      ]
      : [])
  ];
}

export const userProfileData = [
  {
    subHeading: 'First Name',
    inputValue: 'Igor'
  },
  {
    subHeading: 'Last Name',
    inputValue: 'Smith'
  },
  {
    subHeading: 'E-mail address',
    inputValue: 'Igor.Smith@schneider.com'
  },
  {
    subHeading: 'Phone No',
    inputValue: '+ 125-634-7980'
  },
  {
    subHeading: 'Role',
    inputValue: 'Dispatcher'
  },
  {
    subHeading: 'Carrier ID',
    inputValue: '123569'
  }
];
export const NewDropDownData = [
  {
    name: 'Power Only',
    value: 'Power Only'
  },
  {
    name: 'Dry Van',
    value: 'Dry Van'
  },
  {
    name: 'Dray',
    value: 'Dray'
  }, 
  {
    name: 'Refrigerated',
    value: 'Refrigerated'
  },
  {
    name: 'Specialty',
    value: 'Specialty'
  }
];

export const lateReasonOptions = [
  {
    value: "WEATHER",
    key: "WEATHER",
  },
  {
    value: "DRIVER DETENTION",
    key: "DRIVER_DETENTION",
  },
  {
    value: "ROAD CLOSURE",
    key: "ROAD_CLOSURE",
  },
  {
    value: "BREAKDOWN",
    key: "BREAKDOWN",
  }
];

export const declineReasonCodes = [
  {
      "name": "AC_NEXT DAY PU TENDERED AFTER CUTOFF",
      "value": "Next Day PU Tendered After Cutoff"
  },
  {
      "name": "CC_CAPACITY CONSTRAINTS",
      "value": "Capacity Constraints"
  },
  {
      "name": "DL_DELIVERY TIME TOO TIGHT",
      "value": "Delivery Time Too Tight"
  },
  {
      "name": "EC_EQUIPMENT CONSTRAINTS",
      "value": "Equipment Constraints"
  },
  {
      "name": "ET_TYPE OF EQUIPMENT",
      "value": "Type of Equipment"
  },
  {
      "name": "LH_LENGTH OF HAUL UNDESIRABLE",
      "value": "Length of Haul Undesirable"
  },
  {
      "name": "LT_INSUFFICIENT LEAD TIME",
      "value": "Insufficient Lead Time"
  },
  {
      "name": "NT_NO TEAM AVAILABLE",
      "value": "No Team Available"
  },
  {
      "name": "OS_OUTSIDE SERVICE AREA",
      "value": "Outside Service Area"
  },
  {
      "name": "PE_PERMITS",
      "value": "Permits"
  },
  {
      "name": "SU_SHIPMENT UPDATE",
      "value": "Shipment Update"
  },
  {
      "name": "WT_WEIGHT",
      "value": "Weight"
  }
]